/* TMA Parts – gedrag van het thema (auto kiezen, RDW, megamenu, collectiefilters, productpagina, winkelwagen-lade) */
(function(){
"use strict";
const CAT=window.TMA_CAT||[];
const CFG=window.TMA_CFG||{};
const LS_CAR="tma-car";
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>[...r.querySelectorAll(s)];
const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const eur=c=>"€ "+(c/100).toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g,".");
const U=s=>String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toUpperCase().replace(/[^A-Z0-9]/g,"");
const isPhone=()=>matchMedia("(max-width:640px)").matches;
const isNarrow=()=>matchMedia("(max-width:820px)").matches;
const reduce=()=>matchMedia("(prefers-reduced-motion: reduce)").matches;
const WA_ICON='<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.1 5.1 0 0 0 1.1 2.7 11.6 11.6 0 0 0 4.4 3.9c1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>';
const CHECK='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
const CARSVG='<svg width="40" height="18" viewBox="0 0 46 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 14v-3l5-6h19l7 6 8 1.5V14"/><circle cx="11" cy="15" r="2.6"/><circle cx="34" cy="15" r="2.6"/></svg>';
const CARICO='<svg width="22" height="15" viewBox="0 0 26 18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 12.5V10l2.5-5h13l4 5 2.5 1v1.5"/><circle cx="7" cy="13.5" r="2.2"/><circle cx="19" cy="13.5" r="2.2"/></svg>';
const SOORTEN=[["trekhaken","Trekhaken & modules","trekhaken-modules"],["multimedia-navigatie","Multimedia & navigatie","multimedia-navigatie"],["verlichting","Verlichting","verlichting"],["parkeersensoren","Parkeersensoren","parkeersensoren"],["interieur","Interieur","interieur"],["exterieur","Exterieur","exterieur"]];
const CONDS=["Nieuw","Zo goed als nieuw","Gebruikt"];
const PRICES=[["","Alle prijzen",0,1e12],["lt100","Tot € 100",0,10000],["100-250","€ 100 – € 250",10000,25000],["gt250","Vanaf € 250",25000,1e12]];
const waHref=t=>CFG.wa?CFG.wa+(t?"?text="+encodeURIComponent(t):""):(CFG.contact||"/pages/contact");

/* ---------- catalogus ---------- */
const brandBy=n=>CAT.find(b=>b.n===n);
const modelBy=(b,m)=>((brandBy(b)||{}).models||[]).find(x=>x.n===m);
const genBy=(b,m,c)=>((modelBy(b,m)||{}).gens||[]).find(g=>g.code===c);
const genName=g=>g.label.indexOf("(")>-1?g.label:`${g.label} (${g.code})`;
const short=b=>b==="Volkswagen"?"VW":b;
function mkCar(b,m,c){
  const B=brandBy(b),M=modelBy(b,m),G=genBy(b,m,c);
  if(!B||!M||!G)return null;
  return {b,m,c,gn:genName(G),label:`${short(b)} ${genName(G)}`,tags:[B.tag,M.tag,G.tag],url:`/collections/${M.handle}/${G.tag}`};
}
const fitsTags=(tags,car)=>!!car&&car.tags.every(t=>tags.indexOf(t)>-1);
const tagsOf=el=>String(el.dataset.tags||"").split("|").filter(Boolean);

/* ---------- auto onthouden ---------- */
let car=null;
try{const s=JSON.parse(localStorage.getItem(LS_CAR)||"null");if(s)car=mkCar(s.b,s.m,s.c)}catch(e){}
function saveCar(c){
  car=c;
  try{c?localStorage.setItem(LS_CAR,JSON.stringify({b:c.b,m:c.m,c:c.c})):localStorage.removeItem(LS_CAR)}catch(e){}
  document.dispatchEvent(new CustomEvent("tma:car"));
}

/* ---------- toast ---------- */
let toastT;
function toast(msg){const t=$("#tma-toast");if(!t)return;t.textContent=msg;t.hidden=false;clearTimeout(toastT);toastT=setTimeout(()=>t.hidden=true,3000)}

/* ---------- RDW-kenteken ---------- */
const fmtPlate=s=>String(s||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
function yearsOf(g){const m=String(g.years||"").match(/(\d{4})\s*[–-]\s*(\d{4})?/);return m?[+m[1],m[2]?+m[2]:9999]:[0,9999]}
async function lookupPlate(raw){
  /* geeft {car} of {choice:[cars]} of null (niet gevonden) */
  const k=fmtPlate(raw);if(!k)return null;
  let v;
  try{
    const ctl=new AbortController();const to=setTimeout(()=>ctl.abort(),8000);
    const r=await fetch("https://opendata.rdw.nl/resource/m9d7-ebf2.json?kenteken="+encodeURIComponent(k),{signal:ctl.signal});
    clearTimeout(to);
    if(!r.ok)return null;
    v=(await r.json())[0];
  }catch(e){return null}
  if(!v)return null;
  const merk=U(v.merk);
  const B=CAT.find(b=>U(b.n)===merk||(merk==="VW"&&b.n==="Volkswagen"));
  if(!B)return null;
  let hb=String(v.handelsbenaming||"").toUpperCase().trim();
  if(U(hb).startsWith(U(B.n)))hb=hb.slice(B.n.length).trim();
  let nh=U(hb);
  /* sportieve varianten koppelen aan het basismodel: S3/RS 3 → A3, SQ5/RSQ8 → Q5/Q8, S5 → A5 (TTS/TT RS beginnen al met TT) */
  if(B.n==="Audi"){nh=nh.replace(/^RSQ(\d)/,"Q$1").replace(/^SQ(\d)/,"Q$1").replace(/^RS(\d)/,"A$1").replace(/^S(\d)/,"A$1")}
  let M=null,best=0;
  B.models.forEach(m=>{const nm=U(m.n);if(nm&&nh.startsWith(nm)&&nm.length>best){M=m;best=nm.length}});
  if(!M){
    const w0=U(hb.split(/[\s\-\/]+/)[0]);
    const c=B.models.filter(m=>U(m.n.split(/[\s]+/)[0])===w0);
    if(c.length===1)M=c[0];
  }
  if(!M)return null;
  const yr=parseInt(String(v.datum_eerste_toelating||"").slice(0,4),10);
  let gens=M.gens;
  if(yr){const g=M.gens.filter(g=>{const [a,b]=yearsOf(g);return yr>=a&&yr<=b});if(g.length)gens=g}
  const cars=gens.map(g=>mkCar(B.n,M.n,g.code)).filter(Boolean);
  if(cars.length===1)return {car:cars[0]};
  if(cars.length>1)return {choice:cars};
  return null;
}

/* ---------- merk/model/generatie-keuzes ---------- */
function opts(sel,items,ph){sel.innerHTML=`<option value="">${esc(ph)}</option>`+items.map(i=>`<option value="${esc(i[0])}">${esc(i[1])}</option>`).join("")}
function wireTriple(b,m,g){
  const fillM=()=>{if(b.value){opts(m,brandBy(b.value).models.map(x=>[x.n,x.n]),"Kies model");m.disabled=false}else{opts(m,[],"Kies eerst merk");m.disabled=true}};
  const fillG=()=>{if(b.value&&m.value){const gens=modelBy(b.value,m.value).gens;opts(g,gens.map(x=>[x.code,`${genName(x)} ${x.years}`]),"Kies generatie");g.disabled=false;if(gens.length===1)g.value=gens[0].code}else{opts(g,[],"Kies eerst model");g.disabled=true}};
  opts(b,CAT.map(x=>[x.n,x.n]),"Kies merk");fillM();fillG();
  b.addEventListener("change",()=>{fillM();fillG()});
  m.addEventListener("change",fillG);
  return {read:()=>b.value&&m.value&&g.value?mkCar(b.value,m.value,g.value):null,set:c=>{b.value=c.b;fillM();m.value=c.m;fillG();g.value=c.c},b,m,g};
}
const PLAIN=(id,ph)=>`<span class="plain"><span class="nl"><i></i>NL</span><input id="${id}" placeholder="${esc(ph)}" maxlength="10" autocomplete="off" spellcheck="false" aria-label="Kenteken"></span>`;
const go=url=>{location.href=url};
const brandUrl=b=>`/collections/${brandBy(b).handle}`;
const modelUrl=(b,m)=>`/collections/${modelBy(b,m).handle}`;

/* ---------- header: mijn auto ---------- */
function renderHeaderCar(){
  const l=$("#mycar-label");if(!l)return;
  l.innerHTML=car?`${car.b==="Volkswagen"?'<span class="brp">VW </span>':""}${esc(car.label.replace(/^VW /,""))} <span class="ck">✓</span>`:"Kies je auto";
  const btn=$("#mycar-btn");if(btn)btn.setAttribute("aria-label",car?`Mijn auto: ${car.label}. Wijzigen`:"Mijn auto kiezen");
}

/* ---------- megamenu (PC) ---------- */
const nav=$("#navlist");
let openBrand=null;
function renderMega(brand){
  const B=brandBy(brand);if(!B)return;
  $("#mtabs").innerHTML=CAT.map(b=>`<button role="tab" type="button" aria-selected="${b.n===brand}" data-tab="${esc(b.n)}">${esc(b.n)}</button>`).join("");
  $("#mmodels").innerHTML=B.models.map(m=>`<div class="mm"><span class="carthumb">${CARSVG}</span><div><a class="mn" href="/collections/${esc(m.handle)}">${esc(m.n)}</a><div class="gens">${m.gens.map(g=>`<a href="/collections/${esc(m.handle)}/${esc(g.tag)}" data-car="${esc(B.n)}|${esc(m.n)}|${esc(g.code)}">${esc(g.label.indexOf("(")>-1?g.code:g.label+" · "+g.code)} · ${esc(g.years)}</a>`).join("")}</div></div></div>`).join("");
  const all=$("#mfoot-all");all.textContent=`Alle ${B.n}-onderdelen →`;all.href=`/collections/${B.handle}`;
  $$("#mtabs button").forEach(t=>t.onclick=()=>{openBrand=t.dataset.tab;setExpanded();renderMega(openBrand)});
}
function setExpanded(){if(nav)nav.querySelectorAll("button[data-brand]").forEach(x=>x.setAttribute("aria-expanded",String(x.dataset.brand===openBrand)))}
function closeMega(){openBrand=null;const m=$("#mega");if(m)m.hidden=true;setExpanded()}
if(nav){
  nav.addEventListener("click",e=>{const b=e.target.closest("button[data-brand]");if(!b)return;if(openBrand===b.dataset.brand){closeMega();return}openBrand=b.dataset.brand;renderMega(openBrand);$("#mega").hidden=false;setExpanded()});
  document.addEventListener("click",e=>{if(openBrand&&!e.target.closest("header.site"))closeMega()});
}
/* generatie kiezen = auto onthouden (link gaat daarna gewoon door) */
document.addEventListener("click",e=>{
  const g=e.target.closest("a[data-car]");if(!g)return;
  const [b,m,c]=g.dataset.car.split("|");const nc=mkCar(b,m,c);if(nc)saveCar(nc);
});

/* ---------- telefoonmenu ---------- */
let mlvl=[];
function renderMnav(){
  const body=$("#mnav-body");if(!body)return;
  if(!mlvl.length){
    body.innerHTML=`<div class="lvl-h">Onderdelen</div><ul>${CAT.map(b=>`<li><button type="button" class="big" data-mb="${esc(b.n)}">${esc(b.n)}<span class="ar">›</span></button></li>`).join("")}<li><a class="all" href="/collections/all">Alle onderdelen →</a></li></ul>
     <div class="lvl-h" style="font-size:17px;color:var(--muted)">Per soort</div><ul>${SOORTEN.map(c=>`<li><a href="/collections/${c[2]}">${esc(c[1])}<span class="ar">›</span></a></li>`).join("")}</ul>`;
  }else if(mlvl.length===1){
    const B=brandBy(mlvl[0]);
    body.innerHTML=`<button type="button" class="back" data-mback>‹ Alle merken</button><div class="lvl-h">${esc(B.n)}</div><ul><li><a class="all" href="/collections/${esc(B.handle)}">Alle ${esc(B.n)}-onderdelen →</a></li>${B.models.map(m=>`<li><button type="button" data-mm2="${esc(m.n)}"><span>${esc(m.n)} <small>${m.gens.length>1?m.gens.length+" generaties":esc(m.gens[0].code)+" · "+esc(m.gens[0].years)}</small></span><span class="ar">›</span></button></li>`).join("")}</ul>`;
  }else{
    const [b,m]=mlvl,M=modelBy(b,m);
    body.innerHTML=`<button type="button" class="back" data-mback>‹ ${esc(b)}</button><div class="lvl-h">${esc(b)} ${esc(m)}</div><ul><li><a class="all" href="/collections/${esc(M.handle)}">Alle ${esc(m)}-onderdelen →</a></li>${M.gens.map(g=>`<li><a href="/collections/${esc(M.handle)}/${esc(g.tag)}" data-car="${esc(b)}|${esc(m)}|${esc(g.code)}"><span>${esc(genName(g))} <small>${esc(g.years)}</small></span><span class="ar">›</span></a></li>`).join("")}</ul>`;
  }
  body.scrollTop=0;
}
function openMnav(){mlvl=[];renderMnav();$("#mnav").hidden=false;$("#mnav-bg").hidden=false;$("#burger").setAttribute("aria-expanded","true");$("#mnav-x").focus()}
function closeMnav(){const n=$("#mnav");if(!n)return;n.hidden=true;$("#mnav-bg").hidden=true;const b=$("#burger");if(b)b.setAttribute("aria-expanded","false")}
if($("#burger")&&$("#mnav")){
  $("#burger").onclick=openMnav;$("#mnav-x").onclick=closeMnav;$("#mnav-bg").onclick=closeMnav;
  $("#mnav").addEventListener("click",e=>{
    const t=e.target.closest("button");if(!t)return;
    if(t.dataset.mb){mlvl=[t.dataset.mb];renderMnav()}
    else if(t.dataset.mm2){mlvl=[mlvl[0],t.dataset.mm2];renderMnav()}
    else if(t.hasAttribute("data-mback")){mlvl.pop();renderMnav()}
  });
}

/* ---------- lichte autokiezer (dialoog, collectie) ---------- */
const pickers={};
function makePicker(id,{onDone=()=>{}}={}){
  const host=document.getElementById(id);if(!host)return null;
  host.className="pk pk-light";
  host.innerHTML=
   `<div class="ftabs" role="tablist" aria-label="Zoek je auto op"><button type="button" role="tab" data-tab="plate" aria-selected="true">Kenteken</button><button type="button" role="tab" data-tab="mm" aria-selected="false">Merk &amp; model</button></div>
    <form data-pane="plate" novalidate>
      <div class="prow">${PLAIN(id+"-plate","Kenteken, bv. AB-123-C")}<button class="go" type="submit">Zoek</button></div>
      <div class="pmsg" aria-live="polite"></div>
    </form>
    <form data-pane="mm" hidden>
      <div class="frow nocat">
        <label for="${id}-b">Merk<select id="${id}-b"></select></label>
        <label for="${id}-m">Model<select id="${id}-m"></select></label>
        <label for="${id}-g">Generatie<select id="${id}-g"></select></label>
        <button class="go" type="submit">Opslaan</button>
      </div>
    </form>`;
  const tri=wireTriple($(`#${id}-b`),$(`#${id}-m`),$(`#${id}-g`));
  const fPlate=host.querySelector('[data-pane="plate"]'),fMM=host.querySelector('[data-pane="mm"]'),msg=host.querySelector(".pmsg"),inp=$(`#${id}-plate`);
  const tab=t=>{host.querySelectorAll("[data-tab]").forEach(b=>b.setAttribute("aria-selected",String(b.dataset.tab===t)));fPlate.hidden=t!=="plate";fMM.hidden=t!=="mm";if(t==="mm"&&car)tri.set(car)};
  host.querySelectorAll("[data-tab]").forEach(b=>b.onclick=()=>tab(b.dataset.tab));
  inp.addEventListener("input",()=>{inp.value=inp.value.toUpperCase();msg.innerHTML=""});
  fPlate.addEventListener("submit",async e=>{e.preventDefault();
    const v=fmtPlate(inp.value);
    if(!v){msg.innerHTML='<span class="warn">Vul je kenteken in.</span>';inp.focus();return}
    msg.innerHTML='<span>Even zoeken…</span>';
    const r=await lookupPlate(v);
    if(!r){msg.innerHTML=`<span class="warn">Kenteken niet gevonden. Kies je merk en model.</span> <button type="button" class="linkbtn" data-to-mm>Kies merk en model</button>`;
      msg.querySelector("[data-to-mm]").onclick=()=>tab("mm");return}
    if(r.choice){
      msg.innerHTML=`<div>Welke generatie?</div><div class="choice">${r.choice.map((c,i)=>`<button type="button" data-i="${i}">${esc(c.label)}</button>`).join("")}</div>`;
      msg.querySelectorAll("[data-i]").forEach(b=>b.onclick=()=>{msg.innerHTML="";saveCar(r.choice[+b.dataset.i]);onDone(car)});
      return}
    msg.innerHTML="";saveCar(r.car);onDone(car);
  });
  fMM.addEventListener("submit",e=>{e.preventDefault();
    const c=tri.read();
    if(c){saveCar(c);onDone(car);return}
    $(`#${id}-`+(tri.b.value?(tri.m.value?"g":"m"):"b")).focus();
  });
  pickers[id]={host,tab,inp,msg};
  return pickers[id];
}

/* ---------- mijn auto (dialoog) ---------- */
function openDlg(tab){
  const d=$("#tma-dlg");if(!d)return;
  if(!pickers.dp)makePicker("dp",{onDone:()=>closeDlg()});
  d.hidden=false;pickers.dp.msg.innerHTML="";pickers.dp.tab(tab||"plate");
  $("#dlg-cur").textContent=car?`Nu: ${car.label}`:"";$("#d-clear").hidden=!car;
  (tab==="mm"?$("#dp-b"):pickers.dp.inp).focus();
}
function closeDlg(){const d=$("#tma-dlg");if(d)d.hidden=true}
if($("#mycar-btn"))$("#mycar-btn").onclick=()=>openDlg();
if($("#tma-dlg")){
  $("#dlg-x").onclick=closeDlg;
  $("#d-clear").onclick=()=>{saveCar(null);closeDlg()};
  $("#tma-dlg").addEventListener("click",e=>{if(e.target.id==="tma-dlg")closeDlg()});
}

/* ---------- rode zoekbalk (homepage) ---------- */
const zb=$("#zb");
let zbEdit=false;
function zbLine(){if(!car||zbEdit)return "";return `<span class="ok">✓</span> ${esc(car.label)} · <button type="button" class="linkbtn" data-zwijzig>wijzig</button>`}
function renderZb(){if(!zb)return;$("#zr1").innerHTML=zbLine();$("#zr2").innerHTML=zbLine()}
if(zb){
  const zt1=wireTriple($("#zb1"),$("#zm1"),$("#zg1"));
  const zt2=wireTriple($("#zb2"),$("#zm2"),$("#zg2"));
  async function zbLookup(inp,res){
    const v=fmtPlate(inp.value);
    if(!v){inp.focus();return}
    res.innerHTML='<span class="wait">Even zoeken…</span>';
    const r=await lookupPlate(v);
    if(!r){res.innerHTML='<span>Kenteken niet gevonden. Kies je merk en model.</span>';return}
    if(r.choice){
      res.innerHTML='<span>Welke generatie?</span><span class="choose">'+r.choice.map((c,i)=>`<button type="button" data-zc="${i}">${esc(c.label)}</button>`).join("")+'</span>';
      res.querySelectorAll("[data-zc]").forEach(b=>b.onclick=()=>{zbEdit=false;inp.dataset.done=v;saveCar(r.choice[+b.dataset.zc])});
      return;
    }
    zbEdit=false;inp.dataset.done=v;saveCar(r.car);
  }
  zb.addEventListener("click",e=>{
    if(e.target.closest("[data-zwijzig]")){zbEdit=true;renderZb();["#zk1","#zk2"].forEach(s=>{$(s).value="";delete $(s).dataset.done});(isNarrow()?$("#zk2"):$("#zk1")).focus()}
    const t=e.target.closest("[data-zt]");
    if(t){$$("#zb [data-zt]").forEach(x=>x.setAttribute("aria-selected",String(x===t)));$("#zp-k").hidden=t.dataset.zt!=="k";$("#zp-m").hidden=t.dataset.zt!=="m"}
  });
  ["#zk1","#zk2"].forEach(s=>$(s).addEventListener("input",e=>{e.target.value=e.target.value.toUpperCase();const r=e.target.id==="zk1"?$("#zr1"):$("#zr2");if(!car||zbEdit)r.innerHTML=""}));
  /* PC: kenteken heeft voorrang; is het kenteken al opgezocht, dan gaat de knop naar de onderdelen */
  $("#zb-pc").addEventListener("submit",e=>{e.preventDefault();
    const inp=$("#zk1"),v=fmtPlate(inp.value);
    if(v){if(inp.dataset.done===v&&car){go(car.url);return}zbLookup(inp,$("#zr1"));return}
    const c=zt1.read();
    if(c){zbEdit=false;saveCar(c);go(c.url);return}
    if(zt1.b.value){go(zt1.m.value?modelUrl(zt1.b.value,zt1.m.value):brandUrl(zt1.b.value));return}
    if(car&&!zbEdit){go(car.url);return}
    inp.focus();
  });
  /* telefoon, tab Kenteken: Zoek zoekt de auto; nog een keer Zoek toont de onderdelen */
  $("#zb-k").addEventListener("submit",e=>{e.preventDefault();
    const inp=$("#zk2"),v=fmtPlate(inp.value);
    if(v&&inp.dataset.done===v&&car){go(car.url);return}
    if(!v&&car&&!zbEdit){go(car.url);return}
    zbLookup(inp,$("#zr2"));
  });
  $("#zb-m").addEventListener("submit",e=>{e.preventDefault();
    const c=zt2.read();
    if(c){zbEdit=false;saveCar(c);go(c.url);return}
    if(zt2.b.value){go(zt2.m.value?modelUrl(zt2.b.value,zt2.m.value):brandUrl(zt2.b.value));return}
    zt2.b.focus();
  });
}

/* ---------- kaarten: "✓ Past" ---------- */
function markCards(root=document){
  $$(".card[data-tags]",root).forEach(c=>{const ok=c.querySelector(".tag.ok");if(ok)ok.hidden=!fitsTags(tagsOf(c),car)});
}

/* ---------- collectie en zoekresultaten ---------- */
const coll=$("#tma-coll");
const st={cats:new Set(),conds:new Set(),b:"",m:"",price:"",sort:"new",onlyFit:false};
let cards=[];
if(coll){
  cards=$$("#cgrid .card");
  cards.forEach((c,i)=>c.dataset.i=i);
  const kind=coll.dataset.kind;
  st.onlyFit=!!car&&(kind==="all"||kind==="soort");
  /* generatietitel uit de catalogus */
  if(coll.dataset.gen&&coll.dataset.brandName&&coll.dataset.modelName){
    const B=brandBy(coll.dataset.brandName),M=B&&B.models.find(m=>m.handle===coll.dataset.modelHandle);
    const G=M&&M.gens.find(g=>g.tag===coll.dataset.gen);
    if(G){$("#c-title").textContent=genName(G);const lc=$("#c-crumbs .gl");if(lc)lc.textContent=genName(G)}
  }
}
function cardMatch(c,useCar){
  const t=tagsOf(c);
  if(st.b){const B=brandBy(st.b);if(!B||t.indexOf(B.tag)<0)return false;if(st.m){const M=modelBy(st.b,st.m);if(!M||t.indexOf(M.tag)<0)return false}}
  if(st.price){const r=PRICES.find(x=>x[0]===st.price);const p=+c.dataset.price;if(!(p>=r[2]&&p<r[3]))return false}
  if(useCar&&!fitsTags(t,car))return false;
  return true;
}
function renderColl(){
  if(!coll)return;
  const useCar=!!car&&st.onlyFit;
  const base=cards.filter(c=>cardMatch(c,useCar));
  const inCat=c=>!st.cats.size||st.cats.has(c.dataset.soort);
  const inCond=c=>!st.conds.size||st.conds.has(c.dataset.cond);
  let list=base.filter(c=>inCat(c)&&inCond(c));
  const key=st.sort;
  list.sort(key==="asc"?(a,b)=>a.dataset.price-b.dataset.price:key==="desc"?(a,b)=>b.dataset.price-a.dataset.price:key==="new"?(a,b)=>(b.dataset.created-a.dataset.created)||(a.dataset.i-b.dataset.i):(a,b)=>a.dataset.i-b.dataset.i);
  const grid=$("#cgrid");
  cards.forEach(c=>c.hidden=true);
  list.forEach(c=>{c.hidden=false;grid.appendChild(c)});
  const n=list.length;
  /* filters met aantallen */
  $("#fs-cat").innerHTML="<legend>Soort</legend>"+SOORTEN.map(s=>{const k=base.filter(c=>c.dataset.soort===s[0]&&inCond(c)).length;return `<label class="opt${k?"":" zero"}"><input type="checkbox" data-f="cats" value="${s[0]}" ${st.cats.has(s[0])?"checked":""}><span>${esc(s[1])}</span><small>${k}</small></label>`}).join("");
  $("#fs-cond").innerHTML="<legend>Conditie</legend>"+CONDS.map(s=>{const k=base.filter(c=>c.dataset.cond===s&&inCat(c)).length;return `<label class="opt${k?"":" zero"}"><input type="checkbox" data-f="conds" value="${esc(s)}" ${st.conds.has(s)?"checked":""}><span>${esc(s)}</span><small>${k}</small></label>`}).join("");
  $("#fs-price").innerHTML="<legend>Prijs</legend>"+PRICES.map(r=>`<label class="opt"><input type="radio" name="price" data-f="price" value="${r[0]}" ${st.price===r[0]?"checked":""}><span>${esc(r[1])}</span></label>`).join("");
  const fb=$("#f-b"),fm=$("#f-m");
  opts(fb,CAT.map(x=>[x.n,x.n]),"Alle merken");fb.value=st.b;
  if(st.b){opts(fm,brandBy(st.b).models.map(x=>[x.n,x.n]),"Alle modellen");fm.disabled=false;fm.value=st.m}else{opts(fm,[],"Kies eerst merk");fm.disabled=true}
  /* aantal */
  const cnt=useCar?(n===1?"1 onderdeel past":`${n} onderdelen passen`):(n===1?"1 onderdeel":`${n} onderdelen`);
  $("#c-count").textContent=cnt;
  /* dunne regel: auto + schakelaar, of compact kentekenveld */
  const cb=$("#cbar");
  if(coll&&coll.dataset.kind==="diensten"){cb.innerHTML="";cb.hidden=true}
  else if(car){
    cb.innerHTML=`<div class="ccar">${CARICO}<span>${esc(car.label)} <span class="ok">✓</span></span><button type="button" class="linkbtn" id="cb-change">wijzig</button></div><label class="fswitch" for="c-only"><input type="checkbox" id="c-only" ${st.onlyFit?"checked":""}><span class="tr"></span>Alleen wat past</label>`;
    $("#cb-change").onclick=()=>openDlg();
    $("#c-only").onchange=e=>{st.onlyFit=e.target.checked;renderColl()};
  }else{
    cb.innerHTML=`<div class="cplate"><form id="cp-form" novalidate>${PLAIN("cp-plate","Kenteken")}<button class="go" type="submit">Zoek</button></form><span class="cpm">of <button type="button" class="linkbtn" id="cp-mm">kies merk en model</button></span><div class="cmsg2" id="cp-msg" aria-live="polite"></div></div>`;
    $("#cp-mm").onclick=()=>openDlg("mm");
    const inp=$("#cp-plate"),msg=$("#cp-msg");
    inp.addEventListener("input",()=>{inp.value=inp.value.toUpperCase();msg.innerHTML=""});
    $("#cp-form").addEventListener("submit",async e=>{e.preventDefault();
      const v=fmtPlate(inp.value);if(!v){inp.focus();return}
      msg.innerHTML='<span style="color:var(--muted);font-weight:500">Even zoeken…</span>';
      const r=await lookupPlate(v);
      if(!r){msg.textContent="Kenteken niet gevonden. Kies je merk en model.";return}
      if(r.choice){msg.innerHTML=`<span style="color:var(--text)">Welke generatie?</span><span class="choice">${r.choice.map((c,i)=>`<button type="button" data-i="${i}">${esc(c.label)}</button>`).join("")}</span>`;
        msg.querySelectorAll("[data-i]").forEach(b=>b.onclick=()=>{st.onlyFit=true;saveCar(r.choice[+b.dataset.i])});return}
      st.onlyFit=true;saveCar(r.car);
    });
  }
  const nAct=st.cats.size+st.conds.size+(st.b?1:0)+(st.price?1:0);
  $("#f-n").hidden=!nAct;$("#f-n").textContent=nAct;
  $("#f-apply").textContent=`Toon ${n} ${n===1?"onderdeel":"onderdelen"}`;
  $("#sort").value=st.sort;
  const em=$("#c-empty");
  em.hidden=!!n;
  if(!n){
    const q=coll.dataset.kind==="search"&&coll.dataset.q;
    em.innerHTML=`<h3>Geen onderdelen gevonden</h3><p>${useCar?`We hebben nu niets voor jouw ${esc(car.label)} met deze filters.`:(cards.length?"Niets gevonden met deze filters.":(q?"Niets gevonden met deze zoekterm.":"Hier staan nu nog geen onderdelen."))} Stuur ons het onderdeelnummer of een foto, dan kijken we of we het kunnen krijgen.</p><div class="row2">${useCar&&cards.length?'<button type="button" class="btn dark sm" id="e-all">Alles tonen</button>':""}${nAct?'<button type="button" class="btn ghost sm" id="e-clear">Wis filters</button>':""}<a class="btn wa sm" ${waAttr()}>${WA_ICON}WhatsApp ons</a></div>`;
    const ea=$("#e-all");if(ea)ea.onclick=()=>{st.onlyFit=false;renderColl()};
    const ec=$("#e-clear");if(ec)ec.onclick=clearFilters;
  }
  markCards(grid);
}
function waAttr(t){const h=waHref(t);return `href="${esc(h)}"${CFG.wa?' target="_blank" rel="noopener"':""}`}
function clearFilters(){st.cats.clear();st.conds.clear();st.b=st.m="";st.price="";renderColl()}
function openFilters(){$("#fpanel").hidden=false;$("#f-bg").hidden=false;$("#f-close").focus()}
function closeFilters(){const f=$("#fpanel");if(!f)return;f.hidden=true;$("#f-bg").hidden=true}
if(coll){
  $("#filters").addEventListener("change",e=>{const i=e.target.closest("input[data-f]");if(!i)return;
    if(i.dataset.f==="price")st.price=i.value;else{const s=st[i.dataset.f];i.checked?s.add(i.value):s.delete(i.value)}renderColl()});
  $("#f-b").onchange=e=>{st.b=e.target.value;st.m="";renderColl()};
  $("#f-m").onchange=e=>{st.m=e.target.value;renderColl()};
  $("#sort").onchange=e=>{st.sort=e.target.value;renderColl()};
  $("#f-open").onclick=openFilters;$("#f-close").onclick=closeFilters;$("#f-apply").onclick=closeFilters;$("#f-bg").onclick=closeFilters;
  $("#f-clear").onclick=clearFilters;
  renderColl();
}

/* ---------- productpagina ---------- */
const pdp=$("#tma-pdp");
let ptags=[],media=[],gi=0,qty=1;
function renderFitLine(){
  if(!pdp)return;
  const fl=$("#fitline");
  if(fl){
    if(car&&pdp.dataset.rep!=="1"){const ok=fitsTags(ptags,car);fl.className="fitline "+(ok?"ok":"no");fl.innerHTML=ok?`${CHECK} Past op jouw ${esc(car.label)}`:`Past niet op jouw ${esc(car.label)}`;fl.hidden=false}
    else fl.hidden=true;
  }
  /* past op-tabel: gekozen auto groen */
  $$("#p-fits tbody tr").forEach(tr=>{
    const mine=!!car&&fitsTags(ptags,car)&&U(tr.dataset.b)===U(car.b)&&U(tr.textContent).indexOf(U(car.m))>-1&&U(tr.textContent).indexOf(U(car.c))>-1;
    tr.classList.toggle("mine",mine);
    const y=tr.querySelector(".y");if(y){y.querySelectorAll(".me").forEach(x=>x.remove());if(mine)y.insertAdjacentHTML("beforeend",'<span class="me"> · ✓ jouw auto</span>')}
  });
}
if(pdp){
  ptags=tagsOf(pdp);
  try{media=JSON.parse($("#pdp-media").textContent)}catch(e){media=[]}
  const mainimg=$("#mainimg");
  $("#thumbs")&&$("#thumbs").addEventListener("click",e=>{const b=e.target.closest("button");if(!b)return;gi=+b.dataset.i;if(mainimg&&media[gi]){mainimg.src=media[gi].m;mainimg.removeAttribute("srcset")}$$("#thumbs button").forEach(x=>x.setAttribute("aria-current",String(x===b)))});
  const max=Math.max(1,+pdp.dataset.max||5);
  const qo=$("#qty");
  if($("#qminus")){$("#qminus").onclick=()=>{qty=Math.max(1,qty-1);qo.textContent=qty};$("#qplus").onclick=()=>{qty=Math.min(max,qty+1);qo.textContent=qty}}
  const vid=()=>{const s=$("#p-variant");return s?s.value:pdp.dataset.variant};
  const add=async btn=>{btn.disabled=true;await addToCart(vid(),qty);btn.disabled=false};
  $$(".addcart").forEach(b=>b.addEventListener("click",e=>{e.preventDefault();add(b)}));
  const vs=$("#p-variant");
  if(vs)vs.onchange=()=>{const o=vs.selectedOptions[0];if(o&&o.dataset.price){$("#p-price").textContent=o.dataset.price;const sp=$("#sb-price");if(sp)sp.textContent=o.dataset.price}};
  /* lightbox */
  const lb=$("#tma-lb");
  function setLb(){const im=$("#lb-img");im.classList.remove("z");im.src=(media[gi]||{}).l||"";im.alt=pdp.dataset.title||"";$("#lb-cap").textContent=`${media.length>1?`Foto ${gi+1} van ${media.length} · `:""}Klik op de foto om in te zoomen`}
  function openLb(){if(!media.length)return;lb.hidden=false;setLb();$("#lb-pv").hidden=$("#lb-nx").hidden=media.length<2;$("#lb-x").focus();document.body.style.overflow="hidden"}
  function closeLb(){lb.hidden=true;document.body.style.overflow="";const m=$("#mainbtn");if(m)m.focus()}
  if(lb&&$("#mainbtn")){
    $("#mainbtn").onclick=openLb;$("#lb-x").onclick=closeLb;
    $("#lb-pv").onclick=()=>{gi=(gi-1+media.length)%media.length;setLb()};
    $("#lb-nx").onclick=()=>{gi=(gi+1)%media.length;setLb()};
    $("#lb-img").addEventListener("click",e=>{const im=e.currentTarget;if(im.classList.contains("z")){im.classList.remove("z");return}const r=im.getBoundingClientRect();im.style.transformOrigin=`${((e.clientX-r.left)/r.width*100).toFixed(1)}% ${((e.clientY-r.top)/r.height*100).toFixed(1)}%`;im.classList.add("z")});
    lb.addEventListener("click",e=>{if(e.target.id==="tma-lb")closeLb()});
    document.addEventListener("keydown",e=>{if(e.key==="Escape"&&!lb.hidden)closeLb()});
  }
  renderFitLine();
}
/* vaste koopbalk op telefoon: pas zichtbaar als je voorbij de knop bent */
function updateSticky(){
  const sb=$("#stickybuy"),ab=$("#addbtn");if(!sb||!ab)return;
  sb.hidden=!(isPhone()&&ab.getBoundingClientRect().bottom<0);
}
addEventListener("scroll",updateSticky,{passive:true});addEventListener("resize",updateSticky);

/* "meer voor jouw auto" / vergelijkbare onderdelen */
function renderRelated(){
  const host=$("#tma-related");if(!host)return;
  const grid=$("#relgrid"),list=$$(".card",grid);
  if(!list.length){host.hidden=true;return}
  const cur=pdp?ptags:[];
  const sold=pdp&&pdp.dataset.available==="0";
  const soort=SOORTEN.map(s=>s[0]).find(s=>cur.indexOf(s)>-1);
  const curModels=[];CAT.forEach(B=>{if(cur.indexOf(B.tag)>-1)B.models.forEach(M=>{if(cur.indexOf(M.tag)>-1)curModels.push([B.tag,M.tag])})});
  const shareModel=t=>curModels.some(([b,m])=>t.indexOf(b)>-1&&t.indexOf(m)>-1);
  const shareGen=t=>t.some(x=>x.indexOf("gen-")===0&&cur.indexOf(x)>-1)&&shareModel(t);
  let pick=[],head=host.dataset.hDefault||"Meer onderdelen";
  if(sold){
    const sc=c=>{const t=tagsOf(c);return (soort&&t.indexOf(soort)>-1?1:0)+(shareModel(t)?2:0)};
    pick=list.filter(c=>sc(c)>0).sort((a,b)=>sc(b)-sc(a));head="Vergelijkbare onderdelen";
  }else if(car){
    pick=list.filter(c=>fitsTags(tagsOf(c),car));head=`Meer voor jouw ${car.label}`;
  }else{
    pick=list.filter(c=>shareGen(tagsOf(c)));head="Meer voor deze auto";
  }
  if(!pick.length){pick=list;head=sold?"Vergelijkbare onderdelen":"Meer onderdelen"}
  list.forEach(c=>c.hidden=true);
  pick.slice(0,4).forEach(c=>{c.hidden=false;grid.appendChild(c)});
  $("#rel-h").textContent=head;
  markCards(grid);
}

/* ---------- winkelwagen (lade, Ajax Cart API) ---------- */
const SEC="tma-cart-drawer";
function cartEls(){return {d:$("#cdrawer"),bg:$("#cd-bg")}}
function openCart(){const {d,bg}=cartEls();if(!d)return;d.hidden=false;bg.hidden=false;const x=$("#cd-x");if(x)x.focus()}
function closeCart(){const {d,bg}=cartEls();if(!d)return;d.hidden=true;bg.hidden=true}
function syncCount(){const d=$("#cdrawer");if(!d)return;const n=+d.dataset.count||0;const c=$("#cartcount");if(c)c.textContent=n;const b=$("#cart-btn");if(b)b.setAttribute("aria-label",`Winkelwagen openen, ${n} ${n===1?"artikel":"artikelen"}`)}
function swapDrawer(html,keepOpen){
  if(!html)return;
  const wrap=document.getElementById("shopify-section-"+SEC);if(!wrap)return;
  const tmp=document.createElement("div");tmp.innerHTML=html;
  const nw=tmp.querySelector("#shopify-section-"+SEC);
  wrap.innerHTML=nw?nw.innerHTML:tmp.innerHTML;
  syncCount();
  if(keepOpen)openCart();
}
async function refreshDrawer(open){
  try{const r=await fetch(`${location.pathname}?sections=${SEC}`);const j=await r.json();swapDrawer(j[SEC],open)}catch(e){}
}
async function addToCart(id,n){
  try{
    const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:+id,quantity:n}],sections:SEC})});
    const j=await r.json();
    if(!r.ok){await refreshDrawer(true);const m=$("#cdrawer .cmsg");if(m)m.textContent=j.description||j.message||"Dit kon niet worden toegevoegd.";else toast(j.description||"Dit kon niet worden toegevoegd.");return}
    if(j.sections&&j.sections[SEC])swapDrawer(j.sections[SEC],true);else await refreshDrawer(true);
  }catch(e){toast("Er ging iets mis. Probeer het nog eens.")}
}
async function changeLine(line,q){
  try{
    const r=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({line:+line,quantity:q,sections:SEC})});
    const j=await r.json();
    if(!r.ok){await refreshDrawer(true);const m=$("#cdrawer .cmsg");if(m)m.textContent=j.description||j.message||"";return}
    if(j.sections&&j.sections[SEC])swapDrawer(j.sections[SEC],true);else await refreshDrawer(true);
  }catch(e){}
}
document.addEventListener("click",e=>{
  const cb=e.target.closest("#cart-btn");if(cb&&$("#cdrawer")){e.preventDefault();openCart();return}
  if(e.target.closest("#cd-x")||e.target.closest("#cd-bg")){closeCart();return}
  const t=e.target.closest("#cdrawer button");if(!t)return;
  const it=t.closest(".it");
  if(t.dataset.d&&it){const q=Math.max(1,Math.min(+it.dataset.max||5,(+it.dataset.qty)+(+t.dataset.d)));if(q!==+it.dataset.qty){t.disabled=true;changeLine(it.dataset.line,q)}}
  else if(t.dataset.rm&&it){t.disabled=true;changeLine(it.dataset.line,0)}
  else if(t.hasAttribute("data-close"))closeCart();
});
addEventListener("pageshow",e=>{if(e.persisted)refreshDrawer(false)});

/* ---------- algemeen ---------- */
document.addEventListener("keydown",e=>{if(e.key!=="Escape")return;closeDlg();closeMega();closeMnav();closeCart();closeFilters()});
/* zoeken: onderdeelnummer met of zonder spaties */
$$("form[data-tma-search]").forEach(f=>f.addEventListener("submit",()=>{
  const i=f.querySelector('input[name="q"]');if(!i)return;
  const v=i.value.trim();
  if(/^[0-9A-Z]{3}[\s.\-]?[0-9A-Z]{3}[\s.\-]?[0-9A-Z]{3}(\s?[A-Z]{1,3})?$/i.test(v)&&/\d/.test(v))i.value=v.replace(/[\s.\-]/g,"").toUpperCase();
}));
function syncPh(){const q=$("#q");if(q)q.placeholder=isPhone()?"Onderdeel, nummer of model":"Zoek op onderdeel, onderdeelnummer of model"}
/* aankondiging: op telefoon één regel die wisselt */
let ai=0;setInterval(()=>{if(!isPhone()||reduce())return;const s=$$("#announce span");if(s.length<2)return;s[ai].classList.remove("on");ai=(ai+1)%s.length;s[ai].classList.add("on")},4000);
/* headerhoogte voor sticky kolommen */
function setHH(){const h=$("#hdr");if(h)document.body.style.setProperty("--hh",h.offsetHeight+"px")}
addEventListener("resize",()=>{setHH();syncPh()});

/* ---------- alles bijwerken na autokeuze ---------- */
function renderCarUI(){renderHeaderCar();renderZb();markCards();if(coll)renderColl();renderFitLine();renderRelated()}
document.addEventListener("tma:car",renderCarUI);
/* andere tab wijzigt de auto */
addEventListener("storage",e=>{if(e.key===LS_CAR){try{const s=JSON.parse(e.newValue||"null");car=s?mkCar(s.b,s.m,s.c):null}catch(x){car=null}renderCarUI()}});

syncPh();setHH();syncCount();renderCarUI();
window.TMA={openCart,closeCart,addToCart,openDlg,saveCar,lookupPlate,get car(){return car}};
})();
